import React from 'react'
import styled from 'styled-components'

const imagePath = '/images/home'

const txtColor = '#FFF3F4'

const InfoText = styled.p`
  color: ${txtColor};
  text-align: justify;
  font-style: normal;
  font-weight: 400 !important;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
`

const InfoSubTitle = styled.h4`
  color: ${txtColor};
  font-weight: bold;
  font-size: 34px;
  opacity: 0.5;

  ${({ theme }) => theme.mediaQueries.lg} {
  }
`
const InfoTitle = styled.h3`
  color: ${txtColor};
  font-weight: bold;
  font-size: 60px;
  margin: 10px 0 20px 0;

  ${({ theme }) => theme.mediaQueries.lg} {
  }
`
const FarmCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 0px;

  .second {
    flex-direction: column-reverse;
  }

  div {
    width: 100%;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    /* flex-direction: column; */
    flex-direction: row;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    margin-bottom: 64px;
  }
`

const ImgContainer = styled.div`
  padding: 32px;

  ${({ theme }) => theme.mediaQueries.sm} {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    padding: 10px 64px 10px 10px;
  }
`

const FarmCard2 = styled(FarmCard)`
  flex-direction: column;
  margin-bottom: 0px;

  ${({ theme }) => theme.mediaQueries.md} {
    /* flex-direction: column; */
    flex-direction: row-reverse;
  }
`

const Info = () => {
  return (
    <>
      <FarmCard>
        <ImgContainer>
          <img src={`${imagePath}/limo-lico-lp.png`} alt="" />
        </ImgContainer>
        <div style={{ padding: 32 }}>
          <InfoSubTitle>Liquid NFTs</InfoSubTitle>
          <InfoTitle>What are they?</InfoTitle>
          <InfoText>
            Liquid NFTs are NFT collections tokenized as fungible tokens (like BEP-20 tokens) enabling them to be
            instantly traded on decentralized exchanges such as ApeSwap, and making it possible to benefit from DeFi
            features such as yielding and staking.
          </InfoText>
        </div>
      </FarmCard>

      <FarmCard2>
        <div style={{ padding: 32 }}>
          <InfoSubTitle>NFT indexes</InfoSubTitle>
          <InfoTitle>How do they work?</InfoTitle>
          <InfoText>
            NFT indexes are the liquid part of Liquid NFTs and each collection has its own. They can be swapped both
            ways with NFTs from their collection and can also be used to yield and stake.
            <br />
            <br />
            LIMOi is the Liquid Monsters NFT index.
          </InfoText>
        </div>
        <ImgContainer>
          <img src={`${imagePath}/indexinfo.svg`} alt="NFT index info" />
          <InfoText style={{ textAlign: 'right', width: '100%' }}>
            NFTs indexes are identified
            <br /> with a <i>i</i> symbol
          </InfoText>
        </ImgContainer>
      </FarmCard2>
    </>
  )
}

export default Info
